import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';
import EmptyHelpLinksImageComponent from '@atlassian/jira-illustrations/src/ui/adg4/jira/spots/software/components/empty-help-links';
import { useIntl } from '@atlassian/jira-intl';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { SpaStatePageReady } from '@atlassian/jira-spa-state-controller/src/components/main.tsx';
import messages from './messages';

type EmptyLinkSectionProps = {
	onAddLinkClick: () => void;
};
export const EmptyLinkSection = (props: EmptyLinkSectionProps) => {
	const { onAddLinkClick } = props;
	const { formatMessage } = useIntl();

	return (
		<EmptyLinkSectionWrapper>
			<EmptyHelpLinksImageComponent alt={formatMessage(messages.externalLinkEmptyImageAlt)} />
			<EmptyLinkSectionHeading>
				{formatMessage(messages.externalLinkEmptySectionHeader)}
			</EmptyLinkSectionHeading>
			<EmptyLinkSectionBody>
				{formatMessage(messages.externalLinkEmptySectionBody)}
			</EmptyLinkSectionBody>
			<Button
				appearance="primary"
				onClick={(_, analyticsEvent) => {
					fireUIAnalytics(analyticsEvent, 'externalResourceAdd', {
						isEmpty: true,
					});
					onAddLinkClick();
				}}
				data-testId="servicedesk-external-links.ui.links.empty-link-section.add-link-button"
			>
				{formatMessage(messages.externalLinkEmptySectionAddLinkButton)}
			</Button>
			{/* SpaStatePageReady is used to indicate that the app can move to the "afterPaint" phase in react-loosely-lazy. */}
			{fg('jsm_simplified_project_settings_navigation') && <SpaStatePageReady />}
		</EmptyLinkSectionWrapper>
	);
};

export default EmptyLinkSection;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EmptyLinkSectionWrapper = styled.div({
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	margin: `${token('space.800', '64px')} auto 0 auto`,
	padding: token('space.800', '64px'),
	maxWidth: '600px',
	boxSizing: 'border-box',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EmptyLinkSectionHeading = styled.h3({
	marginTop: token('space.600', '48px'),
	marginBottom: token('space.200', '16px'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const EmptyLinkSectionBody = styled.p({
	marginTop: 0,
	marginBottom: token('space.300', '24px'),
	textAlign: 'center',
});
